module.exports = __webpack_public_path__ + "static/monei_pay_starbucks_2_es-4a29ae57f6579735186d84a64deb345a.png";